// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorComponent_errorContainer__01myL","errorMessage":"ErrorComponent_errorMessage__DC-yo"};